import axios from "axios";

export const getDomains = async () => {
  try {
    const response = await axios.get("/api/domains");
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
